(function () {
  var sha256, timer;

  function xhrSuccess () { this.callback.apply(this, this.arguments); }
  function xhrError () { console.error(this.statusText); }

  function upToDate() {
    console.log("UpToDate check...");
    var xhr = new XMLHttpRequest();
    xhr.callback = function () {
          if (sha256) {
            if (this.responseText !== sha256) {
              var href = window.location.href;
              clearInterval(timer);
              var ok = confirm('Shrimp/&#x1f525; has been updated and will automatically refresh.');
              if (ok) {
                window.location.reload(true);
                return;
              } else {
                // restart timer
                timer = setInterval(upToDate, 60 * 1000 * 14);
              }
            }
          } else {
            sha256 = this.responseText || "srcSha=unknown";
            var sig = document.getElementById('sig'),
                buildId = 'V3.5.' + (sha256.substring(7).substr(-6) || 'SNAPSHOT');
            if (sig) {
              sig.innerText = buildId;
              sig.setAttribute("title", buildId);
            } else {
              console.error('Element with id "sig" not found');
            }
          }
        };
    xhr.onload = xhrSuccess;
    xhr.onerror = xhrError;
    xhr.open("GET", ".sha256", true);
    xhr.setRequestHeader('Cache-Control', 'no-cache');
    xhr.setRequestHeader('Pragma', 'no-cache');
    xhr.overrideMimeType('text/plain');
    xhr.send(null);
  }

  console.log("UpToDate loaded");

  document.addEventListener("DOMContentLoaded", upToDate);

  // Check for updates every 14 minutes
  timer = setInterval(upToDate, 60 * 1000 * 14);
})();
